
import { Injectable, Component } from '@angular/core';
import { ConfigService } from "./ConfigService";


@Injectable()

export class UrlService {

	constructor(public configData: ConfigService) { }

	getURL(factoryName: string) {
		var returnVal = this.configData.apiBaseUrl();
		if (!returnVal.endsWith('/')) {
			returnVal += '/';
		}
		switch (factoryName) {
			default:
				returnVal += 'api/v1/' + factoryName;
				break;
		}
		return returnVal;
	}
}


